<template lang="html">

 <article class="col-33 art-dest"  data="fadeInUp">
  <div class="img-destacado -backgroundLoad">
    <hollow-dots-spinner
    :animation-duration="1000"
    :dot-size="20"
    :dots-num="3"
    color="#054279"
    />
  </div>
  <div class="text-dest">
    <span class="date"></span>
    <div class="container-text">
      <h3 class="-backgroundLoad"></h3>
      <div class="flex row-reserve justify-between">
        <ul class="flex row">
          <li><i class="fa fa-eye" aria-hidden="true"></i><span></span></li>
          <li><i class="fa fa-comment-o" aria-hidden="true"></i><span></span></li>
        </ul>
        <a class="mas-dark"></a>
      </div>
    </div>
  </div>
</article>

</template>

<script lang="js">



  import { HollowDotsSpinner } from 'epic-spinners'

  export default  {
    name: 'noticia-el',
    props: ['data'],
    components : {
     HollowDotsSpinner
   },
 }
</script>

<style scoped>
.art-dest{
  opacity: 1;
}

.hollow-dots-spinner{
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.date{
  width: 105px;
  height: 30px;
  display: block;
}

h3{
  width: 80%;
  height: 25px;
  line-height: 25px;
  display: inline-block;
  opacity: .5;
}

.-backgroundLoad{
  -webkit-animation: GrisAnimation 2s ease infinite;
  -moz-animation: GrisAnimation 2s ease infinite;
  animation: GrisAnimation 2s ease infinite;
  background: linear-gradient(274deg, rgba(0,0,0,.05), rgba(0,0,0,.1));
  background-size: 400% 400%;
}

@keyframes GrisAnimation { 
  0%{background-position:0% 48%}
  50%{background-position:100% 53%}
  100%{background-position:0% 48%}
}


</style>



// WEBPACK FOOTER //
// src/components/parts/noticia-fake.vue